import { ToastsProvider } from 'react-bootstrap-toasts';

export const AppLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <ToastsProvider toastContainerProps={{ position: 'top-center', className: 'p-3' }}>
      <>{children}</>
    </ToastsProvider>
  );
};
